import Header from "./SectionHeader";
import ContentGrid from "./SectionContentGrid";
import ContentFull from "./SectionContentFull";
import ContentFullCarousel from "./SectionContentFullCarousel";
import ContentFullCarouselV2 from "./SectionContentFullCarouselV2";
import { RefObject } from "react";
import { SxProps } from "@mui/material";
import DailyDealsContent from "pages/LoyaltyShop/components/DailyDealsContent";
import { SectionSource } from "interfaces/web-store/section-source";

const displayTypes = {
	full: "full",
	grid: "grid"
};
type displayType = (typeof displayTypes)[keyof typeof displayTypes];

const Section = ({
	offers,
	sectionRef,
	headerText,
	sectionPage,
	display = "full",
	Content = ContentFull,
	isHideShowLess = false,
	icon,
	headerSx,
	from
}: {
	offers: JSX.Element[];
	sectionRef: RefObject<HTMLElement>;
	headerText: string;
	sectionPage: string;
	display?: displayType;
	Content?: ({
		items,
		isHideShowLess,
		sectionName,
		sectionPage,
		from
	}: {
		items: JSX.Element[];
		isHideShowLess: boolean;
		sectionName: string;
		sectionPage: string;
		from?: SectionSource;
	}) => JSX.Element;
	isHideShowLess?: boolean;
	iconUrl: string;
	icon: JSX.Element;
	headerSx?: SxProps;
	from?: SectionSource;
}) => {
	if (display === "grid") {
		Content = ContentGrid;
	} else if (display === "carousel") {
		Content = ContentFullCarousel;
	} else if (display === "carouselv2") {
		Content = ContentFullCarouselV2;
	} else if (display === "DailyDealsCarousel") {
		Content = DailyDealsContent;
	}

	return (
		<>
			{offers.length > 0 && (
				<section ref={sectionRef} id={headerText}>
					<Header text={headerText} icon={icon} sx={headerSx} />
					<Content
						items={offers}
						isHideShowLess={isHideShowLess}
						sectionName={headerText}
						sectionPage={sectionPage}
						from={from}
					/>
				</section>
			)}
		</>
	);
};

export default Section;
